<template>
  <div id="app">
    <div class="guide-box flex-wrapper" v-if="!isClient">
      <img src="./assets/logo.png" alt="">
      <span class="flex-wrapper" @click="jumpApp()">立即打开</span>
    </div>
    <div class="video_wrap"
         v-if="detailsData && detailsData.video_list && detailsData.video_list.length && detailsData.video_list[0].url">
      <!-- <video :src="detailsData.video_list[0].url" :poster="detailsData.cover_image"></video>
       -->
      <video-player class="video-player" ref="videoPlayer" :options="playerOptions"></video-player>
    </div>
    <div class="detail-box">
      <div class="detail-wrap" v-if="detailsData">

        <p class="title">{{ detailsData.title }}</p>
        <div class="source" style="display: flex; flex-direction: column;">
          <div style="display: flex;flex-direction: row;justify-content: space-between;">
            <span>{{ detailsData.published_time }}</span>
            <span style="float:right;" v-if="enableDZ && readCount!==0">阅读量 {{ readCount }}</span>
          </div>
          <span>{{ detailsData.source }}</span>
        </div>
        <div class="content-wrap">
          <div v-html="detailsData.content" class="content"></div>
          <p class="author" v-if="detailsData.biandao">
            编导 : {{ detailsData.biandao }}
          </p>
          <p class="author" v-if="detailsData.houqi">
            后期 : {{ detailsData.houqi }}
          </p>
        </div>
        <div class="like-wrapper" v-if="enableDZ">
          <div class="like-box">
            <span class="like-icon" @click="isLogin?toggleLike():goLogin()" :class="{liked:liked}"></span>
            <span class="like-count">{{ likeCount }}</span>
          </div>
        </div>
        <a class="ad-wrap" href="javascript:void(0)" v-if="adImg" @click="openNewWindow(adUrl)">
          <span v-if="newsTag">{{ newsTag }}</span>
          <img :src="adImg" alt="">
        </a>
      </div>

      <div class="recommend-list-wrap" v-if="recommendList.length">
        <div class="flex-wrapper recommend-head">
          <span style="margin-right:15px;"></span>
          <font>相关推荐</font>
          <span style="margin-left:15px;"></span>
        </div>

        <div class="recommend-list">
          <div class="flex-wrapper recommend-cell" v-for="(item,ind) in recommendList" :key="ind"
               @click="jumpDetail(item.video_id,item.title)">
            <div class="flex-wrapper recommend-cell-text" :class="{'auto-height':!item.cover_image}">
              <p class="recommend-title">{{ item.title }}</p>
              <p class="recommend-date">{{ item.published_time }}</p>
            </div>
            <img :src="item.cover_image" alt="" v-if="item.cover_image">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
import UTILS from '../../common/utils'

export default {
  name: 'app',
  data() {
    return {
      enableDZ: !parseInt(process.env.VUE_APP_DZ_TEST) || !!UTILS.getQueryString('tdz'),
      detailsData: {},
      recommendList: [],
      isLogin: false,
      isClient: this.$isClient,
      adImg: '',
      adUrl: '',
      newsTag: '',
      playerOptions: {
        autoplay: false,
        width: document.body.offsetWidth,
        muted: false,
        language: 'zh',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          // mp4
          src: "",
        }],
        poster: "",
      },
      readCount: 0,
      fLikeCount: 0,
      liked: false,
      likeCount: 0,
      userId: 0
    }
  },
  components: {
    // HelloWorld
  },
  mounted() {
    this.getCount()
    this.getAd();
    this.checkLogin();
    this.$axios.get('/wealth/video_detail?video_id=' + this.videoId).then(res => {
      this.detailsData = res.data.data
      if (res.data.data.video_list && res.data.data.video_list.length) {
        this.playerOptions.sources[0].src = res.data.data.video_list[0].url
      }
      this.playerOptions.poster = res.data.data.cover_image
      this.recommendList = res.data.data.recommend_list || []
      if (res.data.data && res.data.data.id) {
        window.document.title = res.data.data.title || '中国财富-视频详情'
        UTILS.loadTRStat(this.detailsData.id, this.detailsData.published_time, this.detailsData.biandao, this.detailsData.source)
      }
      this.addTongji()
      // alert(111333)
      setTimeout(() => {
        let _video = document.getElementsByTagName('video')[0]
        if (_video) {
          // webkit-playsinline="true" playsinline="true" preload="auto" x5-playsinline="true" x-webkit-airplay="allow" poster="" raw-controls="true" 
          _video.setAttribute('webkit-playsinline', true)
          _video.setAttribute('playsinline', true)
          _video.setAttribute('x5-playsinline', true)
        }
      }, 1000)
      let shareTitle = this.detailsData.title || '中国财富资讯'
      // let shareImg = this.detailsData.cover_image || "https://a.cfbond.com/cfbond/logo.jpg"
      let shareImg = process.env.VUE_APP_SHARE_ICON_COMMON
      try {
        window.wx.ready(function () {
          window.wx.updateAppMessageShareData({
            title: shareTitle, // 分享标题
            desc: "来自中国财富传媒集团",
            link: location.href, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: function () {
              // alert("成功");
            },
            cancel: function () {
              // alert("失败")
            }
          })
          window.wx.updateTimelineShareData({
            title: shareTitle, // 分享标题
            link: location.href, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: function () {
              // alert("成功");
            },
            cancel: function () {
              // alert("失败")
            }
          })
        })
        window.wx.error(function (err) {
          // alert(err)
        })
      } catch (err) {
        console.log(err)
      }
    }).catch(err => {
      console.log(err)
    });
    setTimeout(() => {
      this.getLikeCount();
      if (this.isLogin) {
        setTimeout(() => {
          this.getLikeCount();
        }, 3000);
      }
    }, 10);
  },
  methods: {
    addTongji() {
      this.$axios.get(`/wealth/hm.gif?news_id=${this.videoId}&publish_time=${this.detailsData.published_time}&title=${this.detailsData.title}`).then(res => {
      })
    },
    openNewWindow(_url) {
      if (_url) {
        window.open(_url)
      }
    },
    checkLogin() {
      this.$axios.get('/wealth/verify_login_status').then(res => {
        if (res.data.data.login_status) {
          this.isLogin = true;
          this.userId = res.data.data.user_id;
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getCount() {
      this.$axios.get('/wealth/count?news_id=' + this.videoId).then(res => {
        if (res.data.code === 0) {
          this.readCount = res.data.data.count;
          this.fLikeCount = res.data.data.like_count - 0;
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getLikeCount() {

      this.$axios.get('/wealth/get_fav?id=' + this.videoId).then(res => {
        if (res.data.code === 0) {
          this.likeCount = res.data.data.count - 0;
          this.liked = res.data.data.fav;
        }
      }).catch(err => {
        console.log(err)
      });
    },
    toggleLike() {
      this.$axios.post('/wealth/user_fav', {
        id: this.videoId,
        user_id: this.userId,
        type: 1,
        first_type: 'video'
      }).then(res => {
        if (res.data.code === 0) {
          this.liked = !this.liked;
          if (res.data.data) {
            this.likeCount += 1;
          } else {
            this.likeCount -= 1;
          }
        } else {
          console.log(res.data.code + '\t' + res.data.message);
          // alert(res.data.code + '\t' + res.data.message);
        }
      }).catch(err => {
        console.log(err);
        // alert(err.toString());
      });
    },
    getAd() {
      this.$axios.get('/wealth/detail_ad?news_id=' + this.videoId).then(res => {
        if (res.data.code === 0) {
          this.adImg = res.data.data.image;
          this.adUrl = res.data.data.detail_url || ''
          this.newsTag = UTILS.NEWS_TEXT[res.data.data.news_tag] || ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    replaceParamVal(paramName, replaceWith) {
      var oUrl = window.location.href.toString();
      var re = eval('/(' + paramName + '=)([^&]*)/gi');
      var nUrl = oUrl.replace(re, paramName + '=' + replaceWith);
      return nUrl;
    },
    jumpDetail(_id, _title) {
      if (!this.isClient) { //非客户端
        window.location.href = this.replaceParamVal('video_id', _id)
      } else { //客户端
        let _url = this.replaceParamVal('video_id', _id)
        let params = {
          id: _id || '',
          title: _title || '',
          url: _url || '',
          type: 'news'
        }
        if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)) { // IOS
          try {
            window.webkit.messageHandlers.openDetailPage.postMessage(JSON.stringify(params));
          } catch (err) {
            console.log(err)
          }
        } else { // 安卓
          try {
            window.AndroidWebView.openDetailPage(params.id, params.title, params.url, params.type);
          } catch (err) {
            console.log(err)
          }
        }
      }

    },
    goLogin() {
      console.log('ua:', navigator.userAgent)
      if (this.isClient) {
        if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)) {
          console.log('isIOS')
          try {
            window.webkit.messageHandlers.openLoginPage.postMessage('');
          } catch (err) {
            console.log(err)
          }
        } else if (navigator.userAgent.match(/android/gi)) {
          console.log('isAndroid')
          try {
            window.AndroidWebView.openLoginPage();
          } catch (err) {
            console.log(err)
          }
        } else {
          console.log('isUnknownSys')
          this.jumpApp()
        }
      } else {
        console.log('isUnknownClient')
        this.jumpApp()
      }

    },
    jumpApp() {
      // this.Utils.fixJump({id:this.videoId,mode:5});
      // this.Utils.fixJump({id:this.newsId,mode:1});
      var _id = this.videoId
      var _ori = window.location.origin
      var _url = _ori + '/cfbond/detail/VideoDetail.html?video_id=' + _id
      var urlParam = 'cfbond://com.cfbond.acfw/applinks?id=' + _id + '&mode=5&url=' + _url
      if (navigator.userAgent.match(/android/gi)) {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&android_schema=' + encodeURIComponent(urlParam)
      } else {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&ios_schema=' + encodeURIComponent(urlParam)
      }
      // if(navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)){
      //   window.location.href='https://apps.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E8%B4%A2%E5%AF%8C/id1370729250'
      // } else {
      //   window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.cfw'
      // }
    }
  }
}
</script>

<style scoped>
@import '../../common/style.css';

.detail-box {
  padding: 20px 15px;
}

.title {
  font-size: 22px;
  color: #222;
  line-height: 31px;
  font-weight: bold;
}

.source {
  font-size: 14px;
  color: #999;
  line-height: 20px;
  margin-top: 15px;
}

.recommend-list-wrap {
  margin-top: 60px;
}

.recommend-head {
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #333;
}

.recommend-head span {
  flex: 1;
  height: 1px;
  background: #f1eded;
}

.content {
  margin-top: 15px;
  overflow: hidden;
}

.author {
  color: #888;
  font-size: 18px;
  line-height: 32px;

}

.recommend-list {
  /* padding:0 15px; */
}

.recommend-cell {
  justify-content: space-between;
  border-bottom: 1px solid #E8E8E8;
  padding: 20px 0;
}

.recommend-cell img {
  width: 125px;
  height: 83px;
  flex-shrink: 0;
}

.recommend-cell-text {
  flex-direction: column;
  min-height: 75px;
  justify-content: space-between;
  margin-right: 10px;
}

.recommend-cell-text.auto-height {
  height: auto;
}

.recommend-cell-text.auto-height .recommend-title {
  margin-bottom: 25px;
}

.recommend-title {
  font-size: 17px;
  color: #444;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.recommend-date {
  color: #999;
  font-size: 12px;
}

.hide-content {
  max-height: 300px;
  overflow: hidden;
  position: relative;
}

.hide-content:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 200px;
  bottom: -1px;
  left: 0;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, .7), rgba(255, 255, 255, 1));
}

.login-tips {
  text-align: center;
  font-size: 14px;
  color: #999;
}

.login-button {
  justify-content: center;
  width: 240px;
  margin: 30px auto 0;
  align-items: center;
  background-color: #3078EE;
  height: 44px;
  color: #fff;
  font-size: 18px;
  border-radius: 3px;
}

.login-button img {
  width: 23px;
  margin-right: 10px;
}

.guide-box {
  height: 50px;
  background-color: #F9F9F9;
  align-items: center;
  padding: 0 15px;
  justify-content: space-between;
}

.guide-box img {
  height: 35px;
}

.guide-box span {
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 82px;
  height: 31px;
  background-color: #3078EE;
  border-radius: 3px;
  font-size: 14px;
}

.video_wrap video {
  width: 100%;
}
</style>
<style>
.content p {
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 15px;
  text-indent: 0 !important;
}

.content img, .content p img, .content iframe, .content video {
  width: 100% !important;
}

content img, .content p img {
  height: auto !important;
}

.video_wrap .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1em;
  margin-top: -1em;
  width: 2em;
  height: 2em;
  line-height: 1.98em;
  border-radius: 1em;
  border: none;
  background-color: rgba(0, 0, 0, 0.7);
}

.video-js .vjs-control {
  outline: none;
}

.like-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  margin-top: 80px;
  margin-bottom: 100px;
}

.like-wrapper .like-box {
  width: 120px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #DDDDDD;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
}

.like-wrapper .like-box .like-count {
  width: 15px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-left: 5px;
}

.like-wrapper .like-box .like-icon {
  display: inline-block;
  background: url("./assets/like.svg");
  width: 21px;
  height: 19px;
  background-size: cover;
}

.like-wrapper .like-box .like-icon.liked {
  background: url("./assets/liked.svg");
  background-size: cover;
}
</style>
